import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import { withNamespaces } from "react-i18next";
import { useSelector } from "react-redux";
import { FaEye, FaRegEdit } from "react-icons/fa";
import { ImProfile } from "react-icons/im";

const CreateActionColumn = ({
  select,
  row,
  showProfile = false,
  selectProfileShow,
  t,
}) => {
  function renderTooltip(text, ...props) {
    return (
      <Tooltip id="button-tooltip" {...props}>
        {text}
      </Tooltip>
    );
  }

  const getIconsEdit = () => {
    if (row.id === undefined || ["PENDING", "FAILED"].includes(row.estado)) {
      return <div className="table-icon-wrapper"></div>;
    }
    return (
      <div className="table-icon-wrapper">
        <FaRegEdit onClick={() => select(row)} style={{ fontSize: "large" }} />
      </div>
    );
  };

  const getIconsShowCvs = () => {
    if (row.id === undefined || ["PENDING", "FAILED"].includes(row.estado)) {
      return <div className="table-icon-wrapper"></div>;
    }
    return (
      <div className="table-icon-wrapper">
        <ImProfile
          onClick={() => selectProfileShow(row)}
          style={{ fontSize: "large" }}
        />
      </div>
    );
  };

  const getPreviewIcon = () => {
    return (
      <div className="table-icon-wrapper">
        <FaEye />
      </div>
    );
  };

  return (
    <div className="action-wrapper" style={{ justifyContent: "center" }}>
      {/* <div style={{ display: "flex" }}>
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(t("taskPage.general.preview"))}
        >
          {getPreviewIcon()}
        </OverlayTrigger>
      </div> */}
      <div style={{ display: "flex" }}>
        {showProfile && (
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(t("taskPage.general.proceed"))}
          >
            {getIconsShowCvs()}
          </OverlayTrigger>
        )}
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(t("taskPage.general.proceed"))}
        >
          {getIconsEdit()}
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default withNamespaces()(CreateActionColumn);
